<template>
  <v-card min-width="360">
    <v-toolbar color="primary" class="ma-0" dark flat>
      <v-toolbar-title >  
        <h2> <v-icon large class="mr-1">mdi-truck-fast</v-icon><T>Войдите в систему</T></h2>
        <!-- <h2><T>Приходите кушать</T></h2> -->
      </v-toolbar-title>
      <template v-slot:extension>
        <v-tabs
          v-model="tab"
        >
          <v-tab test-tag="tag-74"><T>Оператор</T></v-tab>
          <v-tab test-tag="tag-75"><T>Администратор</T></v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <!-- <Header :app="false"/> -->
    <v-form @submit.prevent="authorize">
      <v-card-text>
        <!-- <v-text-field test-tag="tag-73" @input="error = []" :error-messages="error" v-model="user_code" :disabled="loading" dense label="Код пользователя"></v-text-field> -->
        <v-tabs-items v-model="tab" class="pt-5">
          <v-tab-item>
            <TextField
              v-model="user_code" 
              type="number"
              @focus="e => $store.dispatch('inputFocus', e)"
              :disabled="loading" 
              :label="$t('Код пользователя')"
              :rules="[
                (v) => {return v == '' ? $t('Это обязательное поле') : true}
              ]"  
            />
          </v-tab-item>
          <v-tab-item>
            <TextField 
              v-model="login" 
              @focus="e => $store.dispatch('inputFocus', e)"
              :disabled="loading" 
              :label="$t('Имя пользователя')"
              :rules="[
                (v) => {return v == '' ? $t('Это обязательное поле') : true}
              ]" 
            />
            <TextField 
              v-model="password" 
              @focus="e => $store.dispatch('inputFocus', e)"
              :disabled="loading" 
              password
              :rules="[
                (v) => {return v == '' ? $t('Это обязательное поле') : true}
              ]" 
              :label="$t('Пароль')"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn test-tag="tag-72" :loading="loading" type="submit" text color="primary"> <v-icon small class="mr-2">mdi-login</v-icon><T>Войти</T></v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import TextField from '../common/TextField.vue'

export default {
  data: () => ({
    tab: 0,
    loading: false,
    error: [],
    user_code: '',
    login: '',
    password: ''
  }),
  methods: {
    async authorize(){
      this.loading = true
      try {
        let r = {}
        
        if (this.tab === 0) {
          if (!this.user_code) {
            return 
          }

          r = await this.$store.dispatch('apiQuery', {method: '/auth/operator', body: {user_code: this.user_code}})
        } else {
          if (!this.login || !this.password) {
            return 
          }

          r = await this.$store.dispatch('apiQuery', {method: '/auth/administrator', body: {login: this.login, password: this.password}})
        }
        
        await this.$store.dispatch('login', r.token)

      } finally {
        this.loading = false
      }
    }
  },
  async mounted() {
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('autologin')) {
      this.user_code = urlParams.get('autologin')
      await this.authorize()
    }
  },
  components: {
    TextField
  }
}
</script>